/**
 * 64卦基础信息 - 从Python GuaCi.py移植
 */

export interface HexagramInfo {
  name: string;           // 卦名
  alternate: string;      // 别名
  meaning: string;        // 含义
}

export const gua_ci: Record<string, HexagramInfo> = {
  "i_111111": { name: "乾卦", alternate: "乾为天", meaning: "刚健中正" },
  "i_110111": { name: "夬卦", alternate: "泽天夬", meaning: "决而能和" },
  "i_101111": { name: "大有卦", alternate: "火天大有", meaning: "顺天依时" },
  "i_100111": { name: "大壮卦", alternate: "雷天大壮", meaning: "壮勿妄动" },
  "i_011111": { name: "小畜卦", alternate: "风天小畜", meaning: "蓄养待进" },
  "i_010111": { name: "需卦", alternate: "水天需", meaning: "守正待机" },
  "i_001111": { name: "大畜卦", alternate: "山天大畜", meaning: "止而不止" },
  "i_000111": { name: "泰卦", alternate: "地天泰", meaning: "应时而变" },
  "i_111110": { name: "履卦", alternate: "天泽履", meaning: "脚踏实地" },
  "i_110110": { name: "兑卦", alternate: "兑为泽", meaning: "刚内柔外" },
  "i_101110": { name: "睽卦", alternate: "火泽睽", meaning: "异中求同" },
  "i_100110": { name: "归妹卦", alternate: "雷泽归妹", meaning: "立家兴业" },
  "i_011110": { name: "中孚卦", alternate: "风泽中孚", meaning: "诚信立身" },
  "i_010110": { name: "节卦", alternate: "水泽节", meaning: "万物有节" },
  "i_001110": { name: "损卦", alternate: "山泽损", meaning: "损益制衡" },
  "i_000110": { name: "临卦", alternate: "地泽临", meaning: "教民保民" },
  "i_111101": { name: "同人卦", alternate: "天火同人", meaning: "上下和同" },
  "i_110101": { name: "革卦", alternate: "泽火革", meaning: "顺天应人" },
  "i_101101": { name: "离卦", alternate: "离为火", meaning: "附和依托" },
  "i_100101": { name: "丰卦", alternate: "雷火丰", meaning: "日中则斜" },
  "i_011101": { name: "家人卦", alternate: "风火家人", meaning: "诚威治业" },
  "i_010101": { name: "既济卦", alternate: "水火既济", meaning: "盛极将衰" },
  "i_001101": { name: "贲卦", alternate: "山火贲", meaning: "饰外扬质" },
  "i_000101": { name: "明夷卦", alternate: "地火明夷", meaning: "晦而转明" },
  "i_111100": { name: "无妄卦", alternate: "天雷无妄", meaning: "无妄而得" },
  "i_110100": { name: "随卦", alternate: "泽雷随", meaning: "随时变通" },
  "i_101100": { name: "噬嗑卦", alternate: "火雷噬嗑", meaning: "刚柔相济" },
  "i_100100": { name: "震卦", alternate: "震为雷", meaning: "临危不乱" },
  "i_011100": { name: "益卦", alternate: "风雷益", meaning: "损上益下" },
  "i_010100": { name: "屯卦", alternate: "水雷屯", meaning: "起始维艰" },
  "i_001100": { name: "颐卦", alternate: "山雷颐", meaning: "纯正以养" },
  "i_000100": { name: "复卦", alternate: "地雷复", meaning: "寓动于顺" },
  "i_111011": { name: "姤卦", alternate: "天风姤", meaning: "天下有风" },
  "i_110011": { name: "大过卦", alternate: "泽风大过", meaning: "非常行动" },
  "i_101011": { name: "鼎卦", alternate: "火风鼎", meaning: "稳重图变" },
  "i_100011": { name: "恒卦", alternate: "雷风恒", meaning: "恒心有成" },
  "i_011011": { name: "巽卦", alternate: "巽为风", meaning: "谦逊受益" },
  "i_010011": { name: "井卦", alternate: "水风井", meaning: "求贤若渴" },
  "i_001011": { name: "蛊卦", alternate: "山风蛊", meaning: "振疲起衰" },
  "i_000011": { name: "升卦", alternate: "地风升", meaning: "柔顺谦虚" },
  "i_111010": { name: "讼卦", alternate: "天水讼", meaning: "慎争戒讼" },
  "i_110010": { name: "困卦", alternate: "泽水困", meaning: "困境求通" },
  "i_101010": { name: "未济卦", alternate: "火水未济", meaning: "事业未竟" },
  "i_100010": { name: "解卦", alternate: "雷水解", meaning: "柔道致治" },
  "i_011010": { name: "涣卦", alternate: "风水涣", meaning: "拯救涣散" },
  "i_010010": { name: "坎卦", alternate: "坎为水", meaning: "行险用险" },
  "i_001010": { name: "蒙卦", alternate: "山水蒙", meaning: "启蒙奋发" },
  "i_000010": { name: "师卦", alternate: "地水师", meaning: "行险而顺" },
  "i_111001": { name: "遁卦", alternate: "天山遁", meaning: "遁世救世" },
  "i_110001": { name: "咸卦", alternate: "泽山咸", meaning: "相互感应" },
  "i_101001": { name: "旅卦", alternate: "火山旅", meaning: "依义顺时" },
  "i_100001": { name: "小过卦", alternate: "雷山小过", meaning: "行动有度" },
  "i_011001": { name: "渐卦", alternate: "风山渐", meaning: "渐进蓄德" },
  "i_010001": { name: "蹇卦", alternate: "水山蹇", meaning: "险阻在前" },
  "i_001001": { name: "艮卦", alternate: "艮为山", meaning: "动静适时" },
  "i_000001": { name: "谦卦", alternate: "地山谦", meaning: "内高外低" },
  "i_111000": { name: "否卦", alternate: "天地否", meaning: "不交不通" },
  "i_110000": { name: "萃卦", alternate: "泽地萃", meaning: "荟萃聚集" },
  "i_101000": { name: "晋卦", alternate: "火地晋", meaning: "求进发展" },
  "i_100000": { name: "豫卦", alternate: "雷地豫", meaning: "顺时依势" },
  "i_011000": { name: "观卦", alternate: "风地观", meaning: "观下瞻上" },
  "i_010000": { name: "比卦", alternate: "水地比", meaning: "诚信团结" },
  "i_001000": { name: "剥卦", alternate: "山地剥", meaning: "顺势而止" },
  "i_000000": { name: "坤卦", alternate: "坤为地", meaning: "柔顺伸展" }
};